import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './Common/Components/layout/layout.component';
import { ContactUsComponent } from './Common/Components/contact-us/contact-us.component';
import { FaqComponent } from './Common/Components/faq/faq.component';
import { AboutUsComponent } from './Common/Components/about-us/about-us.component';
import { Header2Component } from './Common/Components/header2/header2.component';
import { HomeComponent } from './Common/Components/home/home.component';
import { UserlayoutComponent } from './Common/Components/userlayout/userlayout.component';
import { LoginComponent } from './Common/Components/login/login.component';
import { AdminLayoutComponent } from './Common/Components/adminComponents/admin-layout/admin-layout.component';
import { AdminDashboardComponent } from './Common/Components/adminComponents/admin-dashboard/admin-dashboard.component';
import { UsercreationComponent } from './Common/Components/adminComponents/usercreation/usercreation.component';
import { UploaddocumentComponent } from './Common/Components/adminComponents/uploaddocument/uploaddocument.component';
import { PromotionAdsComponent } from './Common/Components/adminComponents/promotion-ads/promotion-ads.component';
import { AdminContactUsComponent } from './Common/Components/adminComponents/admin-contact-us/admin-contact-us.component';
import { PushNotificationComponent } from './Common/Components/adminComponents/push-notification/push-notification.component';
import { MotorPageComponent } from './Common/Components/motor-page/motor-page.component';
import { TravelPageComponent } from './Common/Components/travel-page/travel-page.component';
import { FaqHealthInsuranceComponent } from './Common/Components/faq-health-insurance/faq-health-insurance.component';
import { FaqTravelInsuranceComponent } from './Common/Components/faq-travel-insurance/faq-travel-insurance.component';
import { FaqMotorInsuranceComponent } from './Common/Components/faq-motor-insurance/faq-motor-insurance.component';
import { FaqFireInsuranceComponent } from './Common/Components/faq-fire-insurance/faq-fire-insurance.component';
import { HealthPageComponent } from './Common/Components/health-page/health-page.component';
import { HealthsenseAllComponent } from './Common/Components/healthsense-all/healthsense-all.component';
import { HealthsenseExecutiveComponent } from './Common/Components/healthsense-executive/healthsense-executive.component';
import { HealthsensePlatinumComponent } from './Common/Components/healthsense-platinum/healthsense-platinum.component';
import { LanguageSetupComponent } from './Common/Components/adminComponents/language-setup/language-setup.component';
import { PinGeneratonComponent } from './Common/Components/adminComponents/pin-generaton/pin-generaton.component';
import { SessionTimingComponent } from './Common/Components/adminComponents/session-timing/session-timing.component';
import { DashboardMenuComponent } from './Common/Components/adminComponents/dashboard-menu/dashboard-menu.component';
import { FirePageComponent } from './Common/Components/fire-page/fire-page.component';
import { GeneralAccidentComponent } from './Common/Components/general-accident/general-accident.component';
import { AdminImageUploadComponent } from './Common/Components/adminComponents/admin-image-upload/admin-image-upload.component';
import { AuthGuardService } from './Services/auth-guard.service';


const routes: Routes = [

  { path: '', component: LayoutComponent, children: [
    {path: '', redirectTo: 'home', pathMatch: 'full'},
    { path: 'home', component: HomeComponent},
    { path: 'menu', component: Header2Component},
    { path: 'aboutUs', component: AboutUsComponent},
    { path: 'faq', component: FaqComponent},
    { path: 'contactUs', component: ContactUsComponent},
    { path: 'login', component: LoginComponent},
    { path: 'motor', component: MotorPageComponent},
    { path: 'travel', component: TravelPageComponent},
    { path: 'faqhealthinsurance', component: FaqHealthInsuranceComponent},
    { path: 'faqtravelinsurance', component: FaqTravelInsuranceComponent},
    { path: 'faqmotorinsurance', component: FaqMotorInsuranceComponent},
    { path: 'faqfireinsurance', component: FaqFireInsuranceComponent},
    { path: 'health', component: HealthPageComponent},
    { path: 'healthsense-for-all', component: HealthsenseAllComponent},
    { path: 'healthsense-executive', component: HealthsenseExecutiveComponent},
    { path: 'healthsense-platinum', component: HealthsensePlatinumComponent},
    { path: 'fire', component: FirePageComponent},
    { path: 'accident', component: GeneralAccidentComponent},
    ]
  },

  { path: '', component: UserlayoutComponent, 
  //added by durga.b on 11-march-2021 for auth guard
  // canActivate: [AuthGuardService],
  children: [
      {path: '', redirectTo: 'listing/policyListing', pathMatch: 'full'},
      { path: 'dashboard', loadChildren: './Modules/dashboard/dashboard.module#DashboardModule'},
      { path: 'motor', loadChildren: './Modules/motor/motor.module#MotorModule'},
      { path: 'travel', loadChildren: './Modules/travel/travel.module#TravelModule'},
      { path: 'generalAccident', loadChildren: './Modules/generalaccident/generalaccident.module#GeneralaccidentModule'},
      { path: 'property', loadChildren: './Modules/property/property.module#PropertyModule'},
      { path: 'endorsement', loadChildren: './Modules/endorsement/endorsement.module#EndorsementModule'},
      { path: 'claim', loadChildren: './Modules/claim/claim.module#ClaimModule' },
      { path: 'renewal', loadChildren: './Modules/renewal/renewal.module#RenewalModule'},
      { path: 'listing', loadChildren: './Modules/listing/listing.module#ListingModule'},
      { path: 'csr-dashboard', loadChildren: './Modules/dashboard/dashboard.module#DashboardModule'},

    ]
  },
  { path: '', component: AdminLayoutComponent, 
    //added by durga.b on 11-march-2021 for auth guard
    canActivate: [AuthGuardService],
  children: [
    {path: '', redirectTo: 'admindashboard', pathMatch: 'full'},
    { path: 'admindashboard', component: AdminDashboardComponent},
    { path: 'usercreation', component: UsercreationComponent},
    { path: 'uploaddocument', component: UploaddocumentComponent},
    { path: 'promotion-ads', component: PromotionAdsComponent},
    { path: 'notification', component: PushNotificationComponent},
    { path: 'contactus', component: AdminContactUsComponent},
    { path: 'pingeneration', component: PinGeneratonComponent},
    { path:'langsetup',component:LanguageSetupComponent},
    { path:'sessiontime',component:SessionTimingComponent},
    { path:'dashboard-menu',component:DashboardMenuComponent},
    {path:'imageupload',component:AdminImageUploadComponent}

  ]
  },
  {
    path:'medical', component: UserlayoutComponent,
    children: [
      {path:'', loadChildren: './Modules/medical/medical.module#MedicalModule'}
    ]
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppRoutingModule { }
